import { getDialogConfig } from 'src/app/util/dialog-util';
import { VersionDto } from './../../../../../data-transfer/entities/version-dto';
import { ComponentHandler } from 'src/app/services/component-services/component-handler';
import { SelectLocationDialogComponent } from './../../../../directory-tree/dialogs/select-location-dialog/select-location-dialog.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from './../../../../../services/auth-service';
import { PermissionTypeDto } from './../../../../../data-transfer/entities/permission-type-dto';
import { PdfUploadComponent } from './../../../../shared-components/upload/pdf-upload/pdf-upload.component';
import { ImageUploadComponent } from './../../../../shared-components/upload/image-upload/image-upload.component';
import { DialogActions, DictionaryHandler } from './../../../../../model/dictionary';
import { PackagingComponentDto } from '../../../../../data-transfer/entities/component-entities/packaging-component-dto';
import { ComponentTypeService } from 'src/app/navigation/services/component-type-service';
import { ComponentApiService } from '../../../../../data-transfer/services/component-api-service';
import { Observable, Subscription, forkJoin } from 'rxjs';
import { SimpleAlertDialogComponent } from './../../../../dialogs/simple-alert-dialog/simple-alert-dialog.component';
import { FormGroup } from '@angular/forms';
import { Component, OnDestroy, ViewChild } from '@angular/core';
import { ComponentNavigationService } from 'src/app/navigation/services/navigation-services/component-navigation-service';
import { FileApiService } from 'src/app/data-transfer/services/file-api-service';
import { GtinCheckService } from 'src/app/services/component-services/gtin-check-service';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { PackagingComponentTypesEnum } from 'src/app/model/packaging-component-types-enum';
import { VersionComponentDto } from 'src/app/data-transfer/entities/version-component-dto';
import { ComponentTypeDto } from 'src/app/data-transfer/entities/component-type-dto';
import { ComponentSubtypeDto } from 'src/app/data-transfer/entities/component-subtype-dto';
import { interval } from 'rxjs';
import { mergeMap, startWith } from 'rxjs/operators';
import { FOUR_MINUTES, READ_ONLY_SUB_REQUEST_STATUSES_FOR_RECEIVER, TEN_MINUTES } from 'src/app/components/shared-components/parent-components/create-update-packaging-part/create-update-packaging-part.component';
import { CertificateTypeDto } from 'src/app/data-transfer/entities/certificate-type-dto';
import { CertificateUploadComponent } from 'src/app/components/shared-components/upload/certificate-upload/certificate-upload.component';
import { RelevantAnalysisTypes } from 'src/app/util/analyses-util/relevant-analysis-service';
import { DataExchangeRequestApiService } from 'src/app/data-transfer/services/data-exchange-request-api-service';
import { PathResolveService } from 'src/app/services/path-resolve.service';
import { DataExchangeSubRequestInfoDto } from 'src/app/data-transfer/entities/data-exchange-request-entities/data-exchange-sub-request-info-dto';
import { DataExchangeRequestDto } from 'src/app/data-transfer/entities/data-exchange-request-entities/data-exchange-request-dto';
import { DataExchangeRequestStatusDto } from 'src/app/data-transfer/entities/data-exchange-request-entities/data-exchange-request-status-dto';
import { UpdateDataExchangeRequestStatusDto } from 'src/app/data-transfer/entities/data-exchange-request-entities/update-data-exchange-request-status-dto';
import { DirectoryApiService } from 'src/app/data-transfer/services/directory-api-service';
import { TranslocoService } from '@jsverse/transloco';
import { CreateDataExchangeRequestDialogComponent, CreateDataExchangeRequestDialogData } from 'src/app/components/directory-tree/dialogs/create-data-exchange-request-dialog/create-data-exchange-request-dialog.component';
import { SimpleDialogData } from 'src/app/components/dialogs/simple-alert-dialog/simple-alert-dialog.component';
import { SubRequestCommentsDialogComponent, SubRequestCommentsDialogData, SubRequestCommentsDialogResult } from 'src/app/components/dialogs/sub-request-comments-dialog/sub-request-comments-dialog.component';
import { DocUploadSectionComponent } from 'src/app/components/shared-components/doc-upload-section/doc-upload-section.component';
@Component({
  selector: 'app-component-create-update-parent',
  templateUrl: './component-create-update-parent.component.html',
  styleUrls: ['./component-create-update-parent.component.scss']
})
export class ComponentCreateUpdateParentComponent implements OnDestroy {

  @ViewChild(ImageUploadComponent) private imageUploadComponent!: ImageUploadComponent;
  @ViewChild(CertificateUploadComponent) private certificateUploadComponent!: CertificateUploadComponent;
  @ViewChild(PdfUploadComponent) private pdfUploadComponent!: PdfUploadComponent;
  @ViewChild(DocUploadSectionComponent) private docUploadComponent!: DocUploadSectionComponent;

  form!: FormGroup;
  isUserValidator = false;
  isUserAdmin = false;
  isHistory = false;
  isPreview = false;
  isFormLocked = false;
  isTracked = false;
  spinnerActive = false;
  filesEdited = false;
  canEditForm = true;
  isEditPermitted = true;
  isInternallyTracked = false;
  permissions!: PermissionTypeDto;
  materialEdited = false;
  relevantAnalysisTypes: RelevantAnalysisTypes = new RelevantAnalysisTypes(false,false,false);

  // Type as seen in the extended list: closure, ..., banderole, label etc.
  componentType!: ComponentTypeDto;
  callerId = -1;

  componentSubtypes: ComponentSubtypeDto[] = [];
  historyVersions: VersionComponentDto[] = [];
  protected allCertificateTypes: CertificateTypeDto[] = [];

  currentDirectoryId?: number;
  isDarkTheme = false;
  imageSource = '';

  isDataExchangeSubRequest = false;
  dataExchangeSubRequestId: number | null = null;
  subRequestInfo: DataExchangeSubRequestInfoDto | null = null;
  isInOngoingDataExchange: DataExchangeRequestDto[] = [];
  readonly DataExchangeRequestStatusDto = DataExchangeRequestStatusDto;

  private putComponentSubscription?: Subscription;
  private getComponentSubscription?: Subscription;
  private releaseSubscription?: Subscription;
  private lockSubscription?: Subscription;
  private saveFilesSubscription?: Subscription;
  private subRequestSubscription?: Subscription;
  private dialogSubscription?: Subscription;
  private gtinChangesSubscription?: Subscription;
  private historySubscription?: Subscription;
  private renamingSubscription?: Subscription;
  protected routeParamsSubscription?: Subscription;
  protected routeDataSubscription?: Subscription;
  protected themeSubscription?: Subscription;
  protected valueChangeSubscription?: Subscription;
  protected heartBeatSubscription?: Subscription;

  constructor(
    protected componentHandler: ComponentHandler,
    protected dialog: MatDialog,
    protected spinner: NgxSpinnerService,
    protected componentApiService: ComponentApiService,
    protected navigationService: ComponentNavigationService,
    protected componentTypeService: ComponentTypeService,
    protected dictionaryHandler: DictionaryHandler,
    protected fileApiService: FileApiService,
    protected authService: AuthService,
    protected gtinCheckService: GtinCheckService,
    protected dataExchangeApiService: DataExchangeRequestApiService,
    protected route: ActivatedRoute,
    protected router: Router,
    protected directoryApiService: DirectoryApiService,
    protected translocoService: TranslocoService
  ) {
    this.isUserAdmin = this.authService.isUserAdmin();
    this.isUserValidator = this.authService.isUserValidator();
    this.allCertificateTypes = this.componentHandler.allCertificateTypes;
  }

  protected initComponent(component: PackagingComponentDto, route: ActivatedRoute) {
    this.routeParamsSubscription = route.params.subscribe(params => {
      if (params.candidateId) { this.isPreview = true; }
    });
    this.isEditPermitted = this.permissions?.write ?? true;
    this.isHistory = component.id != null && !component.isCurrentVersion;
    this.isTracked = component.hasExternalTracking ?? false;
    this.relevantAnalysisTypes.ccRelevant = component.isCCRelevant;
    this.relevantAnalysisTypes.lcaRelevant = component.isLCARelevant;
    this.relevantAnalysisTypes.recyclingRelevant = component.isRecyclabilityRelevant;
  }

  protected initGtinCheck() {
    this.gtinChangesSubscription = this.form.controls.gtin.valueChanges.subscribe(async val => {
      this.form.controls.gtin.setValue(val?.trim(), { emitEvent: false });
      await this.gtinCheckService.checkGtinValidity(this.form);
      this.form.controls.gtin.markAsTouched();
    });
  }

  protected fetchComponentPermissions(componentId: number | null | undefined) {
    this.componentApiService.getComponentPermissions(componentId ?? -1).subscribe(permissions => {
      this.permissions = permissions;
      if (this.subRequestInfo?.isReceiver && READ_ONLY_SUB_REQUEST_STATUSES_FOR_RECEIVER.includes(this.subRequestInfo?.subRequest?.status ?? -1)) {
        this.isEditPermitted = false;
      } else {
        this.isEditPermitted = this.permissions?.write ?? true;
      }
      this.disableFormIfRequired();
    });
  }

  protected disableFormIfRequired() {
    const editable = (this.permissions?.write ?? true) && this.isEditPermitted;
    if (this.isHistory || this.isUserValidator || this.isUserAdmin || this.isPreview || !editable || this.isFormLocked) {
      this.canEditForm = false;
      this.form.disable();
    }
  }

  protected async releaseComponent(packagingComponent: PackagingComponentDto) {
    if (!this.isFormLocked && packagingComponent.id != null && !this.isPreview && await this.authService.isSignedIn()) {
      this.releaseSubscription = await this.componentApiService.releasePackagingComponent(packagingComponent.id, true).toPromise();
    }
  }

  private getComponentTypeNameEnglish() {
    return this.componentTypeService.getComponentTypeNameById(this.componentType?.id);
  }

  onHistoryVersionChange(version: number) {
    const selectedVersion = this.historyVersions.find(x => x.versionNumber === version);
    if (!selectedVersion || selectedVersion.id == null) { return; }
    if (selectedVersion.isCurrentVersion) {
      if (this.isInOngoingDataExchange.length > 0) {
        this.navigateToFirstOngoingExchange(selectedVersion.id);
        return;
      }
      if (selectedVersion.packagingComponentCategoryId == PackagingComponentTypesEnum.Decoration) {
        this.navigationService.navigateToDecoration(this.getComponentTypeNameEnglish(),
          selectedVersion.id);
      } else {
        this.navigationService.navigateToComponent(this.getComponentTypeNameEnglish(),
          selectedVersion.id);
      }
    } else {
      if (selectedVersion.versionNumber == null) { return; }
      if (selectedVersion.packagingComponentCategoryId == PackagingComponentTypesEnum.Decoration) {
        this.navigationService.navigateToHistoryDecoration(this.getComponentTypeNameEnglish(),
          selectedVersion.id, selectedVersion.versionNumber);
      } else {
        this.navigationService.navigateToHistoryComponent(this.getComponentTypeNameEnglish(),
          selectedVersion.id, selectedVersion.versionNumber);
      }
    }
  }

  protected navigateToFirstOngoingExchange(componentId: number | null | undefined): void {
    const firstRequest = this.isInOngoingDataExchange[0];
    const subRequest = firstRequest.subRequests?.find(sr => sr.packagingComponent?.id === componentId);
    let path: string;
    if (subRequest) {
      switch (subRequest.packagingComponent?.packagingComponentCategoryId) {
        case PackagingComponentTypesEnum.Closure:
          path = '/' + PathResolveService.getDataExchangeRequestClosurePath(true, subRequest.id);
          break;
        case PackagingComponentTypesEnum.Decoration: {
          const decoType = this.componentTypeService.getComponentTypeNameById(subRequest.packagingComponent?.packagingComponentTypeId);
          path = '/' + PathResolveService.getDataExchangeRequestDecorationPath(true, decoType, subRequest.id);
          break;
        }
        case PackagingComponentTypesEnum.PackagingAid:
          path = '/' + PathResolveService.getDataExchangeRequestPackagingAidPath(true, subRequest.id);
          break;
        case PackagingComponentTypesEnum.Inlay:
          path = '/' + PathResolveService.getDataExchangeRequestInlayPath(true, subRequest.id);
          break;
        default:
          path = '/' + PathResolveService.getDataExchangeRequestMainBodyPath(true, subRequest.id);
      }
    } else {
      path = '/' + PathResolveService.getDataExchangeRequestsPath(true);
    }
    this.router.navigateByUrl(path);
  }

  loadHistoryVersions(componentId: number | null | undefined) {
    if (componentId == null) { return; }
    if (this.historyVersions.length <= 1) {
      this.spinnerActive = true;
      this.historySubscription = this.componentApiService.getComponentHistoryVersions(componentId)
        .subscribe(versions => {
          this.historyVersions = versions.sort((a, b) =>
            b.versionNumber != null && a.versionNumber != null ? b.versionNumber - a.versionNumber : 0);
          this.spinnerActive = false;
        });
    }
  }

  protected async onSubmit(packagingComponent: PackagingComponentDto) {
    this.form.updateValueAndValidity();
    if (this.form.invalid) {
      const dialogData = this.componentHandler.getInvalidDialogData();
      const alertDialogConfig = getDialogConfig(dialogData);
      this.dialog.open(SimpleAlertDialogComponent, alertDialogConfig);
    } else {
      if (this.currentDirectoryId == null) {
        this.proceedToDirectorySelection(packagingComponent);
      } else {
        this.setDataAndPutComponent(packagingComponent);
      }
    }
  }

  onSubRequestCommentAdded(text: string): void {
    if (!this.subRequestInfo) { return; }
    const subRequestId = this.subRequestInfo.subRequest.id;
    this.dataExchangeApiService.addSubRequestComment(subRequestId, text).subscribe({
      next: () => {
        this.dataExchangeApiService.getSubRequestInfo(subRequestId, true).subscribe({
          next: info => { this.subRequestInfo = info; }
        });
      }
    });
  }

  onApproveSubRequest(): void {
    if (!this.subRequestInfo) { return; }
    const dto: UpdateDataExchangeRequestStatusDto = { status: DataExchangeRequestStatusDto.Closed };
    this.dataExchangeApiService.updateSubRequestStatus(this.subRequestInfo.subRequest.id, dto, true).subscribe({
      next: () => this.router.navigateByUrl('/' + PathResolveService.getDataExchangeRequestsPath(true))
    });
  }

  onReopenSubRequest(): void {
    if (!this.subRequestInfo) { return; }
    const title = this.translocoService.translate('dataManagement.dataExchangeRequests.comments.subRequestTitle');
    const data: SubRequestCommentsDialogData = {
      comments: this.subRequestInfo.subRequest.comments,
      title,
      allowOptionalComment: true,
      confirmButtonTranslationKey: 'dataManagement.dataExchangeRequests.buttons.reopenSubRequest',
    };
    const dialogRef = this.dialog.open(SubRequestCommentsDialogComponent, getDialogConfig(data, '500px'));
    dialogRef.afterClosed().subscribe((result: SubRequestCommentsDialogResult | undefined) => {
      if (!result?.confirmed) { return; }

      const dto: UpdateDataExchangeRequestStatusDto = { status: DataExchangeRequestStatusDto.ReOpened };
      this.dataExchangeApiService.updateSubRequestStatus(this.subRequestInfo!.subRequest.id, dto, true).subscribe({
        next: () => {
          if (result.comment) {
            this.dataExchangeApiService.addSubRequestComment(this.subRequestInfo!.subRequest.id, result.comment).subscribe({
              next: () => this.router.navigateByUrl('/' + PathResolveService.getDataExchangeRequestsPath(true))
            });
            return;
          }

          this.router.navigateByUrl('/' + PathResolveService.getDataExchangeRequestsPath(true));
        }
      });
    });
  }

  async createDataExchangeRequest(componentId: number | undefined): Promise<void> {
    if (componentId == null) { return; }
    const securityPrincipals = await this.directoryApiService.getExternalSecurityPrincipals().toPromise();
    if (!securityPrincipals) { return; }
    const dialogData: CreateDataExchangeRequestDialogData = {
      allPrincipals: securityPrincipals,
      componentIds: [componentId]
    };
    const dialogRef = this.dialog.open(CreateDataExchangeRequestDialogComponent, getDialogConfig(dialogData, '50%'));
    dialogRef.afterClosed().subscribe(result => {
      if (!result || result.event === DialogActions.REJECT) { return; }
      this.dataExchangeApiService.createDataExchangeRequest(result.dto, true).subscribe({
        next: _ => {
          const data: SimpleDialogData = {
            title: this.translocoService.translate('common.text.success'),
            messages: [this.translocoService.translate('dataManagement.directory.dialog.dataExchangeRequest.createSuccess')],
            icon: 'info'
          };
          this.dialog.open(SimpleAlertDialogComponent, getDialogConfig(data, '500px'));
        },
        error: _ => {
          const data: SimpleDialogData = {
            title: this.translocoService.translate('common.text.error'),
            messages: [this.translocoService.translate('dataManagement.directory.dialog.dataExchangeRequest.createError')],
            icon: 'error'
          };
          this.dialog.open(SimpleAlertDialogComponent, getDialogConfig(data, '500px'));
        }
      });
    });
  }

  isFormValidForSubRequest(): boolean {
    this.form.markAllAsTouched();
    this.form.updateValueAndValidity();
    if (this.form.invalid) {
      const dialogData = this.componentHandler.getInvalidDialogData();
      this.dialog.open(SimpleAlertDialogComponent, getDialogConfig(dialogData));
      return false;
    }
    return true;
  }

  protected changeVersionName(historyVersion: VersionDto, newName: string, component: PackagingComponentDto) {
    if (historyVersion.id == null || historyVersion.versionNumber == null) { return; }
    this.renamingSubscription = this.componentApiService.
      putRenamePackagingComponent(historyVersion.id, historyVersion.versionNumber, newName, true)
      .subscribe(_ => {
        historyVersion.versionName = newName;
        if (historyVersion.versionNumber === component.version) {
          component.versionName = newName;
        }
      });
  }

  private proceedToDirectorySelection(component: PackagingComponentDto) {
    const rootFolder = this.componentHandler.rootDirectory;
    if (!rootFolder) {
      console.log('No directories available');
      return;
    }
    if (!rootFolder.childDirectories || rootFolder.childDirectories.length < 1) {
      component.directoryId = rootFolder.id;
      this.setDataAndPutComponent(component);
      return;
    }
    const dialogConfig = getDialogConfig({ rootFolder, unreachableFolders: [] }, '500px');
    const dialogRef = this.dialog.open(SelectLocationDialogComponent, dialogConfig);
    this.dialogSubscription = dialogRef.afterClosed().subscribe({
      next: result => {
        if (result.event === DialogActions.REJECT) {
          return;
        }
        component.directoryId = result.data.id;
        this.setDataAndPutComponent(component);
      },
      error: e => {
        console.log(e);
      },
    });
  }

  protected setDataAndUpdateAsSubRequest(
    packagingComponent: PackagingComponentDto,
    subRequestId: number,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    updateFn: (id: number, dto: any, submit?: boolean, stayOnPage?: boolean) => Observable<void>,
    successCallback: () => void
  ): void {
    packagingComponent.distributionCountries = this.form.controls.distributionCountries.value ?? [];

    const newImagesFormData = this.imageUploadComponent.getNewImagesFormData();
    const newCertificatesFormData = this.certificateUploadComponent.getNewCertificatesFormData();
    const newPdfsFormData = this.pdfUploadComponent.getNewPdfsFormData();
    const newDocDocumentsFormData = this.docUploadComponent.getDocumentFormData();

    const imageObservables = this.fileApiService.putImages(newImagesFormData);
    const certificateObservables = this.fileApiService.putDocuments(newCertificatesFormData);
    const pdfObservables = this.fileApiService.putDocuments(newPdfsFormData);
    const docObservables = this.fileApiService.putDocuments(newDocDocumentsFormData);

    this.subRequestSubscription = forkJoin([imageObservables, certificateObservables, pdfObservables,docObservables]).subscribe(allIdsList => {
      const imageIdsList = allIdsList[0];
      const certificateIdsList = allIdsList[1];
      const pdfIdsList = allIdsList[2];
      const docList = allIdsList[3];

      const packagingImageIds = packagingComponent.images.map(x => x.imageId);
      for (const imageId of imageIdsList) {
        if (!packagingImageIds.includes(imageId)) {
          packagingComponent.images.push({ imageId, index: packagingComponent.images.length, isMainImage: false, name: '' });
        }
      }

      this.imageUploadComponent.recalculateImageIndices();
      this.imageUploadComponent.setMainImage();
      this.imageUploadComponent.setImageNames();

      const newPackagingDocuments = this.pdfUploadComponent.pdfs.filter(x => x.documentId == null);
      for (let index = 0; index < pdfIdsList.length; index++) {
        newPackagingDocuments[index].documentId = pdfIdsList[index];
      }

      const newPackagingCertificates = this.certificateUploadComponent.certificates.filter(x => x.documentId == null);
      for (let index = 0; index < certificateIdsList.length; index++) {
        newPackagingCertificates[index].documentId = certificateIdsList[index];
      }

      this.docUploadComponent.updateDOCDocumentsAfterSaving(docList);

      this.spinner.show();
      packagingComponent.isCCRelevant = this.relevantAnalysisTypes.ccRelevant;
      packagingComponent.isLCARelevant = this.relevantAnalysisTypes.lcaRelevant;
      packagingComponent.isRecyclabilityRelevant = this.relevantAnalysisTypes.recyclingRelevant;

      updateFn(subRequestId, packagingComponent, true, true).subscribe({
        next: _ => {
          this.spinner.hide();
          Object.keys(this.form.controls).forEach(control => {
            this.form.controls[control].markAsPristine();
          });
          this.form.markAsPristine();
          this.filesEdited = false;
          successCallback();
        },
        error: e => {
          console.error('An error occurred, ', e);
          const dialogData = this.componentHandler.getFailureDialogData(e);
          this.dialog.open(SimpleAlertDialogComponent, getDialogConfig(dialogData, '400px'));
          this.spinner.hide();
        }
      });
    });
  }

  private setDataAndPutComponent(packagingComponent: PackagingComponentDto) {
    packagingComponent.distributionCountries = this.form.controls.distributionCountries.value ?? [];

    const newImagesFormData = this.imageUploadComponent.getNewImagesFormData();
    const newCertificatesFormData = this.certificateUploadComponent.getNewCertificatesFormData();
    const newPdfsFormData = this.pdfUploadComponent.getNewPdfsFormData();
    const newDocDocumentsFormData = this.docUploadComponent.getDocumentFormData();

    const imageObservables = this.fileApiService.putImages(newImagesFormData);
    const certificateObservables = this.fileApiService.putDocuments(newCertificatesFormData);
    const pdfObservables = this.fileApiService.putDocuments(newPdfsFormData);
    const docObservables = this.fileApiService.putDocuments(newDocDocumentsFormData);

    this.saveFilesSubscription = forkJoin([imageObservables, certificateObservables, pdfObservables, docObservables]).subscribe(async allIdsList => {
      const imageIdsList = allIdsList[0];
      const certificateIdsList = allIdsList[1];
      const pdfIdsList = allIdsList[2];
      const docList = allIdsList[3];

      const packagingImageIds = packagingComponent.images.map(x => x.imageId);
      for (const imageId of imageIdsList) {
        if (!packagingImageIds.includes(imageId)) {
          packagingComponent.images.push({
            imageId, index: packagingComponent.images.length, isMainImage: false, name: ''
          });
        }
      }

      this.imageUploadComponent.recalculateImageIndices();
      this.imageUploadComponent.setMainImage();
      this.imageUploadComponent.setImageNames();

      const newPackagingDocuments = this.pdfUploadComponent.pdfs.filter(x => x.documentId == null);
      for (let index = 0; index < pdfIdsList.length; index++) {
        newPackagingDocuments[index].documentId = pdfIdsList[index];
      }

      const newPackagingCertificates = this.certificateUploadComponent.certificates.filter(x => x.documentId == null);
      for (let index = 0; index < certificateIdsList.length; index++) {
        newPackagingCertificates[index].documentId = certificateIdsList[index];
      }

      this.docUploadComponent.updateDOCDocumentsAfterSaving(docList);

      this.putComponent(packagingComponent);
    });
  }

  private putComponent(packagingComponent: PackagingComponentDto) {
    this.spinner.show();
    packagingComponent.isCCRelevant = this.relevantAnalysisTypes.ccRelevant;
    packagingComponent.isLCARelevant = this.relevantAnalysisTypes.lcaRelevant;
    packagingComponent.isRecyclabilityRelevant = this.relevantAnalysisTypes.recyclingRelevant;
    const componentTypeName = this.getComponentTypeNameEnglish();

    if (this.isDataExchangeSubRequest) {
      const subRequestId = +this.route.snapshot.params['id'];
      this.putComponentSubscription = this.dataExchangeApiService.updateSubRequestPackagingComponent(subRequestId, packagingComponent, componentTypeName, false).subscribe({
        next: _ => {
          this.spinner.hide();
          Object.keys(this.form.controls).forEach(control => {
            this.form.controls[control].markAsPristine();
          });
          this.form.markAsPristine();
          this.filesEdited = false;

          const dialogData = this.componentHandler.getComponentSucessDialogData();
          const alertDialogConfig = getDialogConfig(dialogData, '400px');
          const dialogResult = this.dialog.open(SimpleAlertDialogComponent, alertDialogConfig);
          this.dialogSubscription = dialogResult.afterClosed().subscribe(_ => {
            if (this.componentTypeService.getDecorationSubtypeIds().includes(packagingComponent.packagingComponentSubtypeId)) {
              const decoType = this.componentTypeService.getComponentTypeNameById(packagingComponent?.packagingComponentTypeId);
              const path = PathResolveService.getDataExchangeRequestDecorationPath(true, decoType, subRequestId);
              this.router.navigate([path]);
            } else {
              const path = PathResolveService.getDataExchangeRequestComponentPath(true, componentTypeName, subRequestId);
              this.router.navigate([path]);
            }
          });
        },
        error: e => {
          console.error('An error occurred, ', e);
          const dialogData = this.componentHandler.getFailureDialogData(e);
          const dialogResult =this.dialog.open(SimpleAlertDialogComponent, getDialogConfig(dialogData, '400px'));
          this.spinner.hide();
        }
      });
      return;
    }

    this.putComponentSubscription = this.componentApiService
      .putPackagingComponent(packagingComponent, componentTypeName, true)
      .subscribe({
        next: response => {
          console.log('Response is: ', response);
          this.getComponentSubscription = this.componentApiService
            .getPackagingComponent(componentTypeName, response.id)
            .subscribe(savedComponent => {
              Object.keys(this.form.controls).forEach(control => {
                this.form.controls[control].markAsPristine();
              });
              this.filesEdited = false;

              const dialogData = this.componentHandler.getComponentSucessDialogData();
              const alertDialogConfig = getDialogConfig(dialogData, '400px');
              const dialogResult = this.dialog.open(SimpleAlertDialogComponent, alertDialogConfig);
              this.dialogSubscription = dialogResult.afterClosed().subscribe(_ => {
                if (this.componentTypeService.getDecorationSubtypeIds().includes(packagingComponent.packagingComponentSubtypeId)) {
                  this.navigationService.navigateToHistoryDecoration(
                    componentTypeName,
                    savedComponent.id ?? -1,
                    savedComponent.version ?? -1
                  );
                } else {
                  this.navigationService.navigateToHistoryComponent(
                    componentTypeName,
                    savedComponent.id ?? -1,
                    savedComponent.version ?? -1
                  );
                }
              });
            });
        },
        error: e => {
          console.error('An error occurred, ', e);
          const dialogData = this.componentHandler.getFailureDialogData(e);
          const alertDialogConfig = getDialogConfig(dialogData, '400px');
          this.dialog.open(SimpleAlertDialogComponent, alertDialogConfig);
          this.spinner.hide();
        },
      });
  }

  onFilesEdited() {
    this.filesEdited = true;
  }

  setUpLockAndHeartbeat(packagingComponent?: PackagingComponentDto) {
    this.heartBeatSubscription?.unsubscribe();
    if (this.isUserValidator || this.isPreview) {
      return;
    }
    const componentId = packagingComponent?.id;
    if (componentId == null) {
      this.heartBeatSubscription = interval(TEN_MINUTES)
        .pipe(
          startWith(this.authService.heartbeat()),
          mergeMap(() => this.authService.heartbeat())
        )
        .subscribe((_: any) => {
          console.log('heartbeat');
        });
    } else {
      const lockFunction = () => this.componentApiService.lockPackagingComponent(componentId, true);
      this.heartBeatSubscription = interval(FOUR_MINUTES)
        .pipe(
          startWith(lockFunction()),
          mergeMap(() => lockFunction())
        )
        .subscribe({ next:
          (_: any) => {
            console.log('lock');
          },
          error: e => {
            if (e.status === 409) {
              this.componentHandler.showLockedDialog(this.dialog);
              this.form.disable();
              this.isFormLocked = true;
            }
          }
    });
    }
  }

  ngOnDestroy(): void {
    this.putComponentSubscription?.unsubscribe();
    this.getComponentSubscription?.unsubscribe();
    this.releaseSubscription?.unsubscribe();
    this.lockSubscription?.unsubscribe();
    this.routeParamsSubscription?.unsubscribe();
    this.routeDataSubscription?.unsubscribe();
    this.saveFilesSubscription?.unsubscribe();
    this.subRequestSubscription?.unsubscribe();
    this.dialogSubscription?.unsubscribe();
    this.gtinChangesSubscription?.unsubscribe();
    this.themeSubscription?.unsubscribe();
    this.valueChangeSubscription?.unsubscribe();
    this.historySubscription?.unsubscribe();
    this.renamingSubscription?.unsubscribe();
    this.heartBeatSubscription?.unsubscribe();
  }
}
